import axios from 'axios';
import { API_BASE_URL } from './config';

class ProductService {
    constructor() {
        this.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            withCredentials: true
        });
    }

    // Alle aktivierten Produkte laden, optional nach Kategorie gefiltert
    async getProducts(category) {
        const params = category ? { category } : {};
        const response = await this.axiosInstance.get('/api/products', { params });
        return response.data;
    }

    // Alle Produkte inkl. deaktivierter (Admin-only)
    async getAllProducts() {
        const response = await this.axiosInstance.get('/api/products/all');
        return response.data;
    }

    // Neues Produkt anlegen (Admin-only)
    async createProduct(data) {
        const response = await this.axiosInstance.post('/api/products', data);
        return response.data;
    }

    // Produkt bearbeiten (Admin-only)
    async updateProduct(id, data) {
        const response = await this.axiosInstance.put(`/api/products/${id}`, data);
        return response.data;
    }

    // Produkt löschen (Admin-only)
    async deleteProduct(id) {
        const response = await this.axiosInstance.delete(`/api/products/${id}`);
        return response.data;
    }
}

export const productService = new ProductService();
